import { Fragment, useEffect, useState } from 'react';
import countries from '../../../assets/countries.json';
import { Text } from '../../FormControls/Text';
import { Selector } from '../../FormControls/Selector';
import { Input } from "../../FormControls/Input";
import { ScreenControl } from '../ScreenControl';
import { LoadingComponent } from "../../LoadingComponent";
import { setCountrySrore, setCurrencyStore, setStoreName, createNewStore, setPos } from '../../../../main/slices/storeSlice';
import { AlertBox } from "../../FormControls/alert";
import { useDispatch, useSelector } from 'react-redux';
import { Stack } from '@mui/material';

export const FormInfoStore = () => {
  const dispatch = useDispatch();
  const bank = useSelector(({ bank }) => bank);
  const user = useSelector(({ user }) => user);
  const store = useSelector(({ store }) => store);
  const [loading, setLoading] = useState(true);
  const [createSuccess, setCreateSuccess] = useState(false);
  // ALERT
  const [showAlert, setShowAlert] = useState(false); // view alert
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState('success');
  const [alertTitle, setAlertTitle] = useState(null);
  
  const handleScreenControl = () => {
    return {
      fw: (createSuccess === true ? 0 : -1)
    };
  }

  const handleChangeCountry = (val) => {
    dispatch(setCountrySrore({ value: val?.value, error: !val?.value }));
  };
  
  const onChange = (key, value) => {
    if (key === "storeName"){ dispatch(setStoreName({ value, error: !value })); }
  };

  const createStore = async () => {
    if (user && bank) return await dispatch(createNewStore({
      "origin": "worldpos",
      //BANK INFO
      "bankName": bank.bankName.value,
      "bankAccountNumber": bank.accountNumber.value,
      "bankAccountName": bank.accountName.value,
      "bankAccountCurrency": bank.accountCurrency.value,
      "bankAccountType": bank.accountType.value,
      //USER INFO
      "wldId": user.idWLD,
      "email": user.email.value,
      "userName": user.name.value,
      "userLastName": user.last_name.value,
      "userExtPhone": user.extPhone.value,
      "userPhone": user.phone.value,
      //STORE INFO
      "country": store.country.value,
      "storeName": store.storeName.value,
      "currency": store.currency.value,
    }))
        .unwrap()
        .then(({ response }) => {
          let pos = response.data.pos;
          if (response.code==200) {
            setAlertType('success');
            setAlertMessage(`Tu comercio se ha creado correctamente, revisa la bandeja de entrada de tu correo electróncio para visualizar las credenciales.`);
            setCreateSuccess(true);
            setShowAlert(true);

            //SAVE POS
            dispatch(setPos({ value: pos, error: false }));
            return true;
          }else if(response.code==201){
            setAlertType('success');
            setAlertMessage(`Error al intentar crear el comercio.`);
            setShowAlert(true);
            return true
          }else {
            setAlertType('error');
            setAlertMessage(`Verifica los datos de tu comercio e intentalo nuevamente.`);
            setShowAlert(true);
            return false
          };
        })
        .catch(e => false);

    else {
      setAlertType('error');
      setAlertMessage(`Error inesperado.`);
      setShowAlert(true);
      return false;
    }
  }
  
  function getCurrency(country){
    let currencies = {
      "Guatemala": [{name: "Quetzales" , id: "GTQ"}],
      // "Honduras": [{name: "Lempiras" , id: "HNL"}, {name: "Dolares", id: "USD"}],
      // "El Salvador": [{name: "Dolares", id: "USD"}],
      // "Panama": [{name: "Dolares", id: "USD"}],
      // "Costa Rica": [{name: "Colones" , id: "CRC"}, {name: "Dolares", id: "USD"}],
    }
    
    return currencies[country]
  }
  

  const handleChangeCurrency = (val) => dispatch(setCurrencyStore({ value: val?.value, error: !val?.value }));
  const countryOptions = countries.map((country) => ({
    value: country.displayName,
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img
          src={country.flag}
          alt={country.displayName}
          style={{
            width: "20px",
            height: "14px",
            objectFit: "cover",
            borderRadius: "2px",
          }}
        />
        <span>{country.displayName}</span>
      </div>
    ),
  }));

  const currencyOptions = (getCurrency(store.country.value) || []).map((currency) => ({
    label: currency.name,
    value: currency.id,
  }));

  useEffect(() => {
    // Simula un retraso de 2 segundos (2000 ms)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    // Limpieza por si el componente se desmonta antes
    return () => clearTimeout(timer);
  }, []);


  // GET LOADING PAGE 
  if(loading){ return (<Fragment><LoadingComponent /></Fragment>); }

  // CLOSE ALERT MESSAGE
  const handleCloseAlert = () => setShowAlert(false);

  return (    
    <Fragment>

      {showAlert && (
        <AlertBox
          message={`${alertMessage}`}
          type={alertType}
          title={alertTitle}
          onClose={handleCloseAlert}
        />
      )}
      <div style={{ padding: "0 1.5rem" }}>
        <Stack>
          <Text classes={["title", "center"]}>Información del Comercio</Text>
            <Text classes={["subtitle"]}>
              {" "}
              ¡Casi listo! Configura tu comercio y comienza a recibir pagos a través de la plataforma Recibe.{" "}
            </Text>

            <div style={{ marginBottom: "2rem" }}></div>
              <Stack flex={{ flexDirection: "row", gap: 10}}>
                <Stack flex={{ flexDirection: "column", gap: 4, flex: 1 }}>
                  <Text classes={["description"]}> País </Text>
                  <Selector
                    options={countryOptions}
                    onSelect={handleChangeCountry}
                    defaultValue={store.country.value ? countryOptions.find(c => c.value === store.country.value) : "Seleccionar"}
                    placeholder="Seleccionar"
                  />
                </Stack>
                <Stack flex={{ flexDirection: "column", gap: 4, flex: 1 }}>
                  <Text classes={["description"]}> Moneda </Text>
                  <Selector
                    options={currencyOptions}
                    onSelect={handleChangeCurrency}
                    defaultValue={
                      store.currency.value
                        ? currencyOptions.find((c) => c.value === store.currency.value)
                        : "Seleccionar"
                    }
                    placeholder="Seleccionar"
                  />
                </Stack>
              </Stack>
              
              <div style={{ marginBottom: "1.5rem" }}></div>
              <Stack flex={{ flexDirection: "column", gap: 0 }}>
                <Text classes={["description"]}> Nombre del comercio </Text>
                <div style={{ marginBottom: "-0.5rem" }}></div>
                <Input
                  type="text"
                  placeHolder="Nombre del comercio"
                  classes={[
                    "marginTB1em",
                    store.storeName.value &&
                    store.storeName.error
                      ? "error"
                      : "",
                  ]}
                  onChange={({ target }) => onChange("storeName", target.value)}
                />
              </Stack>
              <div style={{ marginBottom: "1rem" }}></div>
        </Stack>
        
      </div>
      {/* CONTROLLER */}
      <ScreenControl 
        btncolor={"cobrarBtn"}
        btnText={"Crear Comercio"}
        index={{fw: 6 }}
        beforeSubmit={() => createStore()}
        disabled={store.country.error || store.currency.error || store.storeName.error} 
      ></ScreenControl>
    </Fragment>
  );
};